"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bookings = void 0;
const react_1 = __importStar(require("react"));
const react_uid_1 = require("react-uid");
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const ShoppingCartRounded_1 = __importDefault(require("@mui/icons-material/ShoppingCartRounded"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const BookingListItem_1 = __importDefault(require("./BookingListItem"));
// import type { BookingAvailabilityType } from "../../../common/types/BookingAvailability";
const BookingsWrapper = styled_components_1.default.div `
  padding: 16px;
  padding-bottom: 70px;
`;
const SectionHeader = styled_components_1.default.div `
  color: rgba(0, 0, 0, 0.7);
  padding-bottom: 10px;
  font-size: 12px;

  @media (min-width: 768px) {
    padding: 18px 0;
  }
`;
const NoBookingsWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 10vmin;

  p {
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0.5px;
    color: #737373;
  }
`;
const ShoppingCartIconWrapper = styled_components_1.default.span `
  padding: 15px;
  margin-bottom: 25px;
  border-radius: 50%;
  background-color: #e1e6e8;
  line-height: 0;

  .shopping-cart-icon {
    font-size: 45px;
  }
`;
const Bookings = ({ data, fetchNewBookings }) => {
    if (!data || data.length === 0) {
        return (react_1.default.createElement(NoBookingsWrapper, null,
            react_1.default.createElement(ShoppingCartIconWrapper, null,
                react_1.default.createElement(ShoppingCartRounded_1.default, { className: "shopping-cart-icon" })),
            react_1.default.createElement(material_1.Typography, null,
                " ",
                i18n_js_1.default.t("bookings_empty_message"),
                " ")));
    }
    return (react_1.default.createElement(BookingsWrapper, { "data-testid": "bookings" }, data.map((bookingGroup) => {
        const sortedBookings = bookingGroup.bookings.sort((a, b) => new Date(a.isoTime).getTime() - new Date(b.isoTime).getTime());
        return (react_1.default.createElement(react_1.Fragment, { key: (0, react_uid_1.uid)(bookingGroup) },
            react_1.default.createElement(SectionHeader, null, bookingGroup.title.toUpperCase()),
            sortedBookings.map((booking) => (react_1.default.createElement(BookingListItem_1.default, { fetchNewBookings: fetchNewBookings, className: "reservation-item", key: booking.code, data: booking })))));
    })));
};
exports.Bookings = Bookings;
exports.default = exports.Bookings;
